import { noop } from 'lodash';
import type { Context, PropsWithChildren } from 'react';
import React, { Component, createContext } from 'react';

export interface FocusTwinsContextProps {
  readonly rescueChild: () => void;
  readonly childIsAvailable: (focus: () => void) => void;
}

export const FocusTwinsContext: Context<FocusTwinsContextProps> = createContext<FocusTwinsContextProps>({
  rescueChild: noop,
  childIsAvailable: noop,
});

export default class FocusTwinsParent extends Component<PropsWithChildren> {
  private needsRescuing = false;

  private readonly rescueChild = () => {
    this.needsRescuing = true;
  };

  private readonly childIsAvailable = (focus: () => void) => {
    if (this.needsRescuing) {
      this.needsRescuing = false;
      focus();
    }
  };

  private readonly contextValue: FocusTwinsContextProps = {
    rescueChild: this.rescueChild,
    childIsAvailable: this.childIsAvailable,
  };

  public render(): React.JSX.Element {
    return <FocusTwinsContext.Provider value={this.contextValue}>{this.props.children}</FocusTwinsContext.Provider>;
  }
}
